/**
 * Modalità Vacanza — Wishlist v3
 * Stores saved products in localStorage.
 * Works across all pages; renders the wishlist page when #wishlist-page-container is present.
 * Includes variant selector + add-to-cart on the wishlist page.
 * Includes shareable wishlist URL via ?shared= parameter.
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'mv_wishlist_v1';

  // ─── Storage helpers ────────────────────────────────────────────────────────

  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
    } catch (e) {
      return [];
    }
  }

  function saveWishlist(items) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch (e) {}
    updateCounts();
    document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { count: items.length } }));
  }

  function isInWishlist(productId) {
    return getWishlist().some(function (item) { return String(item.id) === String(productId); });
  }

  function addItem(data) {
    var list = getWishlist();
    if (!list.some(function (item) { return String(item.id) === String(data.id); })) {
      list.push(data);
      saveWishlist(list);
    }
  }

  function removeItem(productId) {
    saveWishlist(getWishlist().filter(function (item) { return String(item.id) !== String(productId); }));
  }

  // ─── Count badges ───────────────────────────────────────────────────────────

  function updateCounts() {
    var count = getWishlist().length;
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = count > 0 ? count : '';
      el.setAttribute('aria-label', count + ' saved items');
    });
  }

  // ─── Heart button SVG ────────────────────────────────────────────────────────

  function heartSVG(filled) {
    return '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="22" height="22" '
      + 'fill="' + (filled ? 'currentColor' : 'none') + '" '
      + 'stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" '
      + 'aria-hidden="true">'
      + '<path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78'
      + 'l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>'
      + '</svg>';
  }

  // ─── Initialise heart buttons ────────────────────────────────────────────────

  function initButtons() {
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      var id = btn.dataset.wishlistToggle;
      var inList = isInWishlist(id);
      btn.innerHTML = heartSVG(inList);
      btn.setAttribute('aria-pressed', inList ? 'true' : 'false');
      btn.classList.toggle('is-wishlisted', inList);

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var nowIn = isInWishlist(id);
        if (nowIn) {
          removeItem(id);
          btn.innerHTML = heartSVG(false);
          btn.setAttribute('aria-pressed', 'false');
          btn.classList.remove('is-wishlisted');
        } else {
          addItem({
            id: id,
            handle: btn.dataset.handle || '',
            title: btn.dataset.title || '',
            image: btn.dataset.image || '',
            price: btn.dataset.price || '0',
            url: btn.dataset.url || '/products/' + (btn.dataset.handle || '')
          });
          btn.innerHTML = heartSVG(true);
          btn.setAttribute('aria-pressed', 'true');
          btn.classList.add('is-wishlisted');

          btn.classList.add('wishlist-pulse');
          setTimeout(function () { btn.classList.remove('wishlist-pulse'); }, 400);
        }
      });
    });
  }

  // ─── Format money ────────────────────────────────────────────────────────────

  function formatMoney(cents) {
    var amount = parseInt(cents, 10) / 100;
    return window.Shopify && window.Shopify.currency
      ? window.Shopify.currency.active + ' ' + amount.toFixed(2)
      : '$' + amount.toFixed(2);
  }

  // ─── Refresh Stiletto's quick-cart drawer ────────────────────────────────────

  function refreshStilettoCart(cartData) {
    var count = cartData ? cartData.item_count : 0;
    document.querySelectorAll('[data-js-cart-count]').forEach(function (el) {
      el.textContent = count > 0 ? count : '';
    });

    var qcEl = document.querySelector('[data-section-type="quick-cart"]');
    if (qcEl) {
      var sectionId = qcEl.dataset.sectionId;
      if (sectionId) {
        fetch('/?sections=' + encodeURIComponent(sectionId))
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var html = data[sectionId];
            if (html) {
              var wrapper = document.getElementById('shopify-section-' + sectionId);
              if (wrapper) {
                wrapper.outerHTML = html;
              }
            }
          })
          .catch(function () {});
      }
    }

    document.dispatchEvent(new CustomEvent('cart:item-added', { bubbles: true, detail: { cart: cartData } }));
  }

  // ─── Add to cart ─────────────────────────────────────────────────────────────

  function addToCart(variantId, btn) {
    btn.disabled = true;
    btn.textContent = 'Adding…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('failed');
        return r.json();
      })
      .then(function () {
        btn.textContent = '✓ Added!';
        btn.classList.add('wishlist-atc--added');
        return fetch('/cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) { refreshStilettoCart(cart); });
      })
      .catch(function () {
        btn.textContent = 'View product →';
        btn.classList.add('wishlist-atc--error');
      })
      .then(function () {
        setTimeout(function () {
          btn.disabled = false;
          btn.textContent = 'Add to cart';
          btn.classList.remove('wishlist-atc--added', 'wishlist-atc--error');
        }, 2000);
      });
  }

  // ─── Fetch variants and wire up a card ───────────────────────────────────────

  function initCard(card, handle, readOnly) {
    if (readOnly) return; // shared view — no ATC

    var select = card.querySelector('.wishlist-card__variant-select');
    var atcBtn = card.querySelector('.wishlist-card__add-to-cart');

    fetch('/products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (product) {
        var variants = product.variants;

        if (variants.length === 1) {
          var v = variants[0];
          atcBtn.disabled = !v.available;
          atcBtn.textContent = v.available ? 'Add to cart' : 'Sold out';
          atcBtn.dataset.variantId = v.id;
        } else {
          select.style.display = '';
          variants.forEach(function (v) {
            var opt = document.createElement('option');
            opt.value = v.id;
            opt.textContent = v.title + (v.available ? '' : ' — Sold out');
            opt.disabled = !v.available;
            select.appendChild(opt);
          });

          var firstAvailable = variants.find(function (v) { return v.available; });
          if (firstAvailable) {
            select.value = firstAvailable.id;
            atcBtn.dataset.variantId = firstAvailable.id;
          } else {
            atcBtn.disabled = true;
            atcBtn.textContent = 'Sold out';
          }

          select.addEventListener('change', function () {
            atcBtn.dataset.variantId = select.value;
            var chosen = variants.find(function (v) { return String(v.id) === select.value; });
            atcBtn.disabled = chosen ? !chosen.available : true;
            atcBtn.textContent = (chosen && !chosen.available) ? 'Sold out' : 'Add to cart';
          });
        }

        atcBtn.addEventListener('click', function () {
          var vid = atcBtn.dataset.variantId;
          if (vid) addToCart(Number(vid), atcBtn);
        });
      })
      .catch(function () {
        atcBtn.textContent = 'View product';
        atcBtn.addEventListener('click', function () {
          window.location.href = '/products/' + handle;
        });
      });
  }

  // ─── Share wishlist ──────────────────────────────────────────────────────────

  function encodeSharePayload(list) {
    // Store only the ids and handles — enough to re-render from Shopify product API
    var payload = list.map(function (item) {
      return { id: item.id, handle: item.handle, title: item.title, image: item.image, price: item.price, url: item.url };
    });
    try {
      return btoa(encodeURIComponent(JSON.stringify(payload)));
    } catch (e) {
      return null;
    }
  }

  function decodeSharePayload(encoded) {
    try {
      return JSON.parse(decodeURIComponent(atob(encoded)));
    } catch (e) {
      return null;
    }
  }

  function getSharedParam() {
    try {
      return new URLSearchParams(window.location.search).get('shared');
    } catch (e) {
      return null;
    }
  }

  function renderShareButton(container, list) {
    if (!list.length) return;

    var wrap = document.createElement('div');
    wrap.className = 'wishlist-share-wrap';

    var btn = document.createElement('button');
    btn.className = 'wishlist-share-btn';
    btn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><line x1="8.59" y1="13.51" x2="15.42" y2="17.49"/><line x1="15.41" y1="6.51" x2="8.59" y2="10.49"/></svg> Share wishlist';

    var copyMsg = document.createElement('span');
    copyMsg.className = 'wishlist-share-copied';
    copyMsg.textContent = 'Link copied!';
    copyMsg.setAttribute('aria-live', 'polite');

    btn.addEventListener('click', function () {
      var encoded = encodeSharePayload(list);
      if (!encoded) return;
      var url = window.location.origin + '/pages/wishlist?shared=' + encoded;
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(function () {
          showCopied();
        }).catch(function () {
          fallbackCopy(url);
        });
      } else {
        fallbackCopy(url);
      }
    });

    function showCopied() {
      copyMsg.classList.add('is-visible');
      setTimeout(function () { copyMsg.classList.remove('is-visible'); }, 2500);
    }

    function fallbackCopy(url) {
      var ta = document.createElement('textarea');
      ta.value = url;
      ta.style.position = 'fixed';
      ta.style.opacity = '0';
      document.body.appendChild(ta);
      ta.select();
      try { document.execCommand('copy'); showCopied(); } catch (e) {}
      document.body.removeChild(ta);
    }

    wrap.appendChild(btn);
    wrap.appendChild(copyMsg);
    container.insertAdjacentElement('beforebegin', wrap);
  }

  // ─── Render wishlist page ────────────────────────────────────────────────────

  function renderWishlistPage() {
    var container = document.getElementById('wishlist-page-container');
    if (!container) return;

    var sharedParam = getSharedParam();
    var isShared = Boolean(sharedParam);
    var list = isShared ? (decodeSharePayload(sharedParam) || []) : getWishlist();

    // Shared banner
    if (isShared) {
      var banner = document.createElement('div');
      banner.className = 'wishlist-shared-banner';
      banner.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>'
        + ' Someone shared their wishlist with you!';
      container.insertAdjacentElement('beforebegin', banner);
    }

    if (list.length === 0) {
      container.innerHTML = '<div class="wishlist-empty">'
        + '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="48" height="48" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>'
        + '<h2>' + (isShared ? 'This wishlist is empty' : 'Your wishlist is empty') + '</h2>'
        + '<p>' + (isShared ? 'Nothing has been saved to this wishlist yet.' : 'Save pieces you love by tapping the heart on any product.') + '</p>'
        + '<a href="/collections/all" class="wishlist-shop-btn">Shop the collection</a>'
        + '</div>';
      return;
    }

    var html = '<ul class="wishlist-grid" role="list">';
    list.forEach(function (item) {
      html += '<li class="wishlist-card" data-wishlist-id="' + item.id + '">'
        + '<div class="wishlist-card__image-wrap">'
        + '<a class="wishlist-card__img-link" href="' + item.url + '">'
        + (item.image
          ? '<img src="' + item.image + '" alt="' + item.title + '" loading="lazy" width="400" height="400">'
          : '<div class="wishlist-card__no-image"></div>')
        + '</a>'
        + (!isShared
          ? '<button class="wishlist-card__remove-x" data-remove-id="' + item.id + '" aria-label="Remove ' + item.title + ' from wishlist">'
            + '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2"><line x1="13" y1="1" x2="1" y2="13"/><line x1="1" y1="1" x2="13" y2="13"/></svg>'
            + '</button>'
          : '')
        + '</div>'
        + '<div class="wishlist-card__info">'
        + '<a class="wishlist-card__title-link" href="' + item.url + '">'
        + '<p class="wishlist-card__title">' + item.title + '</p>'
        + '</a>'
        + '<p class="wishlist-card__price">' + formatMoney(item.price) + '</p>'
        + '</div>'
        + (!isShared
          ? '<div class="wishlist-card__atc-wrap">'
            + '<select class="wishlist-card__variant-select" style="display:none" aria-label="Select variant"></select>'
            + '<button class="wishlist-card__add-to-cart" disabled>Loading…</button>'
            + '</div>'
          : '<div class="wishlist-card__atc-wrap">'
            + '<a href="' + item.url + '" class="wishlist-card__view-link">View product</a>'
            + '</div>')
        + '</li>';
    });
    html += '</ul>';

    container.innerHTML = html;

    if (!isShared) {
      // Bind remove (X) buttons
      container.querySelectorAll('.wishlist-card__remove-x').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var id = btn.dataset.removeId;
          removeItem(id);
          var card = container.querySelector('[data-wishlist-id="' + id + '"]');
          if (card) {
            card.style.opacity = '0';
            card.style.transform = 'scale(0.95)';
            setTimeout(function () {
              card.remove();
              if (getWishlist().length === 0) renderWishlistPage();
            }, 200);
          }
        });
      });

      // Share button
      renderShareButton(container, list);

      // Fetch variants for each card
      list.forEach(function (item) {
        var card = container.querySelector('[data-wishlist-id="' + item.id + '"]');
        if (card && item.handle) initCard(card, item.handle, false);
      });
    }
  }

  // ─── Boot ────────────────────────────────────────────────────────────────────

  function init() {
    updateCounts();
    initButtons();
    renderWishlistPage();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Public API
  window.MVWishlist = { get: getWishlist, add: addItem, remove: removeItem, has: isInWishlist };

})();
